import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', padding: "0 25px", overflowWrap: 'break-word' }}>
				<h3 style={{textAlign:'center'}}>Invalid CIN Entry</h3>
				<hr/>
				<p>The member Client Identification Number you entered {this.props.data.CIN} isn’t valid. Please check your records for the correct member Client Identification Number.</p>
				<p>You may re-enter the Client Identification Number, or start over from the beginning.</p>
				<div className="button"  onClick={()=>{this.props.setData('CIN', '');  this.props.navigate('A2')}}>Re-enter CIN</div>
			</div>
		);
	}
}